import { Modal } from "@aidkitorg/component-library";
import AuthPage from "../Auth";

export function AuthPageModal(props: {
  open: boolean;
  onClose: () => void;
  onLoginSuccess: () => void;
}) {
  return <Modal open={props.open} onClose={props.onClose} title={''}>
    <AuthPage onLoginSuccess={props.onLoginSuccess} />
  </Modal>
}
